import { reCaptchaStyles } from "@insite/content-library/Components/ReCaptcha";
import { FORM, TYPOGRAPHY } from "@store/theme/design";
import updateCssValue, { Operators } from "@store/utilities/updateCssValue";
import { css } from "styled-components";

Object.assign(reCaptchaStyles, {
    wrapper: {
        css: css`
            margin-top: ${updateCssValue(FORM.field.spacing, Operators.Divide, 2)};
        `,
    },
    errorMessageText: {
        color: "danger",
        size: TYPOGRAPHY.size.smallest,
        lineHeight: TYPOGRAPHY.lineHeight.small,
        css: css`
            margin-top: 6px;
        `,
    },
});
